function scrollIt() {
  const scrollElems = document.querySelectorAll('.js-scroll-it');
  let clientX = 0;
  let clientY = 0;

  scrollElems.forEach(function(item) {
    const parent = item.closest('.js-scroll-it-container');

    const hideScrollElem = function() {
      item.classList.add('hide');

      setTimeout(function() {
        item.classList.add('stop-animation');
      }, 300);
    };

    parent.addEventListener('touchmove', function(e) {
      hideScrollElem();
    }, false);
  });
};
